import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Skeleton,
} from "@/components/ui";

export function OfficesLoadingCard() {
  return (
    <div role="status" aria-live="polite" className="animate-pulse">
      <Skeleton className="mb-2 h-10 w-1/4 rounded-sm" />
      <Card className="h-[482px]">
        <CardHeader>
          <CardTitle>
            <Skeleton className="mb-2 h-10 w-1/2 rounded-sm" />
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Skeleton className="mb-2 h-6 w-full rounded-sm" />
        </CardContent>
      </Card>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
